import { resolveMediaUrl } from './mediaUrl';

const parseProductCaption = (caption) => {
  if (!caption) {
    return { name: '', description: '', features: [], linkUrl: '' };
  }

  try {
    const parsed = JSON.parse(caption);
    return {
      name: parsed.name || '',
      description: parsed.description || '',
      features: Array.isArray(parsed.features) ? parsed.features : [],
      linkUrl: parsed.linkUrl || '',
    };
  } catch {
    return { name: '', description: '', features: [], linkUrl: '' };
  }
};

export const parseHomeWealthSavingsContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'wealth-savings');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};
  const featureImage =
    section.media?.primary ||
    section.media?.groups?.['feature-image']?.[0] ||
    null;
  const checkIcon = section.media?.groups?.['check-icon']?.[0] || null;
  const productMedia = section.media?.groups?.products || [];

  if (
    !fields.eyebrow ||
    !fields.title ||
    !fields.text ||
    !featureImage?.url ||
    !checkIcon?.url ||
    productMedia.length === 0
  ) {
    return null;
  }

  const products = productMedia
    .map((item) => {
      const parsed = parseProductCaption(item.caption);
      if (!parsed.name || !item.url) {
        return null;
      }

      return {
        name: parsed.name,
        description: parsed.description || '',
        features: parsed.features,
        icon: resolveMediaUrl(item.url),
        to: parsed.linkUrl || '#',
      };
    })
    .filter(Boolean);

  if (products.length === 0) {
    return null;
  }

  return {
    eyebrow: fields.eyebrow,
    title: fields.title,
    text: fields.text,
    cta: {
      text: fields.ctaText || '',
      url: fields.ctaUrl || '',
    },
    featureImage: resolveMediaUrl(featureImage.url),
    checkIcon: resolveMediaUrl(checkIcon.url),
    products,
  };
};
